export default __webpack_public_path__ + "static/media/Wedding-Big.bcc7db4c.png";